// 
// ─── FEATURE FLAGS ───────────────────────────────────────
// Figés au build par CRA : une bascule demande un rebuild du front.
//

// SCAN INVERSE — à false, l'utilisateur présente son QR perso et le manager le
// scanne. À true, l'utilisateur scanne le QR de la boutique. Doit suivre
// SCAN_STORE_ENABLED côté API.
export const SCAN_STORE_ENABLED = process.env.REACT_APP_SCAN_STORE_ENABLED === 'true';
